import React, { useState } from 'react';
import Header from '~/components/layout/Header';
import SideBar from '~/components/layout/Sidebar';
import portalDeCompras from './assets/images/portal_de_compras.jpg';
import parcerias from './assets/images/parcerias.png';
import portalDeComprasAntigo from './assets/images/portal_de_compras_antigo.png';
import subsidioUltragaz2026 from './assets/images/subsidio_ultragaz_2026.png';
import parceriasAntigo from './assets/images/parcerias_antigo.png';
import OpenChatBot from '~/components/layout/Chatbot';
import { fetchBravium } from '../Auth/SingIn';

import { useSelector } from 'react-redux';

import {
  PageContainer,
  Container,
  Content,
  HeaderContainer,
  PageWrapper,
  ClubImageContainer,
  ClubImage,
  MobileImage,
  ClubImageSectionOne,
  ClubImageSectionTwo,
  PortalImage,
  SubsidioLink,
  SubsidioImage,
} from './styles';

const BRAVIUM_SHOPPING_CLUB_ATIVO = false;

const PIPEFY_PARCERIAS_URL =
  'https://app.pipefy.com/organizations/300880142/interfaces/c1681f98-cd74-4977-8dd8-26fef32b18bd';

const PIPEFY_SUBSIDIO_URL =
  'https://app.pipefy.com/public/form/kfsAXkCM';

export default function ShoppingClub() {
  const [loadingPortalCompras, setLoadingPortalCompras] = useState(false);
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );

  const handlePortalComprasClick = async e => {
    e.preventDefault();
    setLoadingPortalCompras(true);
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      console.error('Access token not found');
      setLoadingPortalCompras(false);
      return;
    }
    await fetchBravium(accessToken);
    const braviumUrl = localStorage.getItem('urlBravium');

    if (braviumUrl) {
      window.open(braviumUrl, '_blank');
    }
    setLoadingPortalCompras(false);
  };

  const renderMobileContent = () => {
    if (BRAVIUM_SHOPPING_CLUB_ATIVO) {
      return (
        <ClubImageContainer>
          <a
            onClick={handlePortalComprasClick}
            style={{
              cursor: 'pointer',
              width: '100%',
              display: 'block',
              marginBottom: '20px',
            }}
          >
            <PortalImage
              alt="Banner portal de compras"
              src={portalDeCompras}
              $bravium
            />
          </a>
          <a
            href={PIPEFY_PARCERIAS_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '100%', display: 'block' }}
          >
            <ClubImage alt="Parcerias" src={parcerias} />
          </a>
        </ClubImageContainer>
      );
    }
    return (
      <ClubImageContainer>
        <PortalImage
          alt="Banner portal de compras"
          src={portalDeComprasAntigo}
          $bravium={false}
        />
        <SubsidioLink
          href={PIPEFY_SUBSIDIO_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: '20px' }}
        >
          <SubsidioImage
            alt="Banner informativo Subsídio Ultragaz 2026 com QR Code e link para formulário"
            src={subsidioUltragaz2026}
          />
        </SubsidioLink>
        <a
          href={PIPEFY_PARCERIAS_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ width: '100%', display: 'block', marginTop: '20px' }}
        >
          <ClubImage alt="Parcerias" src={parceriasAntigo} />
        </a>
      </ClubImageContainer>
    );
  };

  const renderDesktopContent = () => {
    if (BRAVIUM_SHOPPING_CLUB_ATIVO) {
      return (
        <>
          <ClubImageSectionOne $bravium>
            <a
              onClick={handlePortalComprasClick}
              style={{ cursor: 'pointer', width: '100%', display: 'block' }}
            >
              <PortalImage
                alt="Banner portal de compras"
                src={portalDeCompras}
                $bravium
              />
            </a>
          </ClubImageSectionOne>
          <ClubImageSectionTwo $bravium>
            <a
              href={PIPEFY_PARCERIAS_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ width: '100%', display: 'block' }}
            >
              <ClubImage alt="Parcerias" src={parcerias} />
            </a>
          </ClubImageSectionTwo>
        </>
      );
    }
    return (
      <>
        <ClubImageSectionOne $bravium={false}>
          <PortalImage
            alt="Banner portal de compras"
            src={portalDeComprasAntigo}
            $bravium={false}
          />
          <SubsidioLink
            href={PIPEFY_SUBSIDIO_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <SubsidioImage
              alt="Banner informativo Subsídio Ultragaz 2026 com QR Code e link para formulário"
              src={subsidioUltragaz2026}
            />
          </SubsidioLink>
        </ClubImageSectionOne>
        <ClubImageSectionTwo $bravium={false}>
          <a
            href={PIPEFY_PARCERIAS_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '100%', display: 'block' }}
          >
            <ClubImage alt="Parcerias" src={parceriasAntigo} />
          </a>
        </ClubImageSectionTwo>
      </>
    );
  };

  return (
    <PageContainer>
      <div className="mobile">
        <SideBar
          menuSelected={'Portal de Compras'}
          hasPendenciOn={classificationReducer.pendenciesOn}
        >
          <Container>
            <Content>
              <HeaderContainer>
                <Header />
              </HeaderContainer>
              <PageWrapper>
                <MobileImage>{renderMobileContent()}</MobileImage>
              </PageWrapper>
            </Content>
          </Container>
          <OpenChatBot />
        </SideBar>
      </div>
      <div className="desktop">
        <SideBar
          menuSelected={'Portal de Compras'}
          hasPendenciOn={classificationReducer.pendenciesOn}
        >
          <Container>
            <Content>
              <HeaderContainer>
                <Header />
              </HeaderContainer>
              <PageWrapper>{renderDesktopContent()}</PageWrapper>
            </Content>
          </Container>
          <OpenChatBot />
        </SideBar>
      </div>
    </PageContainer>
  );
}
